import { createPortal } from 'react-dom';
import { useOnboardingContext } from '@tlx/beehive-shared';
import {
    SalaryOnboardingOptionsReturn,
    useSalaryOnboardingPageOptions,
} from '@Page/Onboarding/hooks/useSalaryOnboardingPageOptions';
import { createContext, useContext } from 'react';

const SalaryOnboardingPageOptionsContext = createContext<SalaryOnboardingOptionsReturn | null>(null);

export function SalaryOnboardingPageOptions({ children }: { children: React.ReactNode }) {
    const values = useSalaryOnboardingPageOptions();

    if (values.isLoading || !values.data) {
        return null;
    }

    return (
        <SalaryOnboardingPageOptionsContext.Provider value={values}>
            {children}
        </SalaryOnboardingPageOptionsContext.Provider>
    );
}

export function useSalaryOnboardingPageOptionsContext() {
    const context = useContext(SalaryOnboardingPageOptionsContext);
    if (!context) {
        throw new Error('SalaryOnboardingPageOptionsContext cannot be rendered outside SalaryOnboardingPageOptions');
    }
    return context;
}

export function SalaryOnboardingWithTips({ children }: { children: React.ReactNode }) {
    return (
        <SalaryOnboardingPageOptions>
            <div className="salary-onboarding__wrapper">
                {children}
                <div id="salary-onboarding-tips-container"></div>
            </div>
        </SalaryOnboardingPageOptions>
    );
}

export function SalaryOnboardingTipsContainer({ stageId, children }: { stageId: string; children: React.ReactNode }) {
    const { activeStage } = useOnboardingContext();

    if (!stageId) {
        throw new Error('No stageId provided');
    }

    const element = document.getElementById('salary-onboarding-tips-container');
    if (!element) {
        return null;
    }

    if (activeStage !== stageId) {
        return null;
    }

    return createPortal(children, element);
}
